import * as types from './types';

const INITIAL_STATE = {
  esperandoInfo: false,
  esperandoSolicitacao: false,
  error: false,
  mensagem: '',
  solicitacao: null,  
  mensagens: {},
  errorStatus: null

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LAUDOS_MEDICOS_LIMPAR_MENSAGEM:
      return { ...state, error: false, mensagem: '' };
    case types.LAUDOS_MEDICOS_INICIO_SOLICITACAO:
      return { ...state, esperandoSolicitacao: true, mensagem: null, error: false }
    case types.LAUDOS_MEDICOS_SOLICITACAO_SUCESSO:
      return { ...state, esperandoSolicitacao: false, solicitacao: action.payload }
    case types.LAUDOS_MEDICOS_SOLICITACAO_ERRO:
      return { ...state, esperandoSolicitacao: false, error: true }
    case types.LAUDOS_MEDICOS_DOWNLOAD_INICIO:
    case types.AVALIACAO_SOCIAL_DOWNLOAD_INICIO:
      return { ...state, esperandoSolicitacao: true }
    case types.LAUDOS_MEDICOS_DOWNLOAD_SUCESSO:
    case types.AVALIACAO_SOCIAL_DOWNLOAD_SUCESSO:
      return { ...state, esperandoSolicitacao: false, mensagem: 'sucesso', error: false }
    case types.LAUDOS_MEDICOS_DOWNLOAD_ERRO:
      return { ...state, esperandoSolicitacao: false, error: true, mensagens: action.payload.msg, errorStatus: action.payload.errorStatus}
    case types.LAUDOS_MEDICOS_SOLICITAR_SUCESSO:
      return { ...state, esperandoSolicitacao: false, solicitacao: action.payload }
    default:
      return state;
  }
}
